import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateServiceMutation } from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";

interface IPROPS {
    closeModal: any;
    refetchingData: any;
    storedData: any;
}

const EditServiceModal: React.FC<IPROPS> = ({ closeModal, refetchingData, storedData }) => {
    const [name, setName] = useState(storedData?.name);
    const [image, setImage] = useState<any>(storedData?.image || "");
    const [icon, setIcon] = useState<any>(storedData?.icon || "");
    const [isImageChanged, setIsImageChanged] = useState(false);
    const [isIconChanged, setIsIconChanged] = useState(false);

    const imageHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setImage(file);
            setIsImageChanged(true);
        }
    };

    const iconHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setIcon(file);
            setIsIconChanged(true);
        }
    };

    const { selectedButtonBackgoundColors, selectedButtonColors } = useThemeColors();

    const [trigger] = useUpdateServiceMutation();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const formData = new FormData();
        let hasChanges = false;

        // ✅ Add name only if changed
        if (name !== storedData?.name) {
            formData.append("name", name);
            hasChanges = true;
        }

        // ✅ Add image only if changed
        if (isImageChanged) {
            formData.append("image", image);
            hasChanges = true;
        }

        // ✅ Add icon only if changed
        if (isIconChanged) {
            formData.append("icon", icon);
            hasChanges = true;
        }

        // ❌ If nothing changed, don't call API
        if (!hasChanges) {
            toast.info("No changes detected");
            return;
        }

        try {
            const response = await trigger({ body: formData, id: storedData?.id });

            if (response?.data) {
                toast.success("Edited successfully");
                closeModal();
                refetchingData();
            } else if ("data" in response?.error) {
                const errorData = response?.error?.data as { extension: string[] };
                toast.error(errorData?.extension?.[0] || "Something went wrong");
            }
        } catch (error) {
            toast.error("An error occurred");
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div>
                <p style={{ margin: 0, display: "flex", justifyContent: "center", fontFamily: "Karbon-medium", fontSize: "20px" }}>
                    Edit Service
                </p>
            </div>

            {/* Name Input */}
            <div>
                <label style={{fontFamily: "Karbon-medium", fontSize: "18px"}}>Edit Service Type</label>
                <input
                style={{fontFamily: "Karbon-regular"}}
                    className="form-control"
                    value={name}
                    onChange={(e) => {
                        const alphaValue = e.target.value.replace(/[^a-zA-Z ]/g, "");
                        setName(alphaValue);
                    }}
                />
            </div>

            {/* Image Upload */}
            <div style={{ display: "flex", width: "100%", gap: "20px", flexDirection: "column" }}>
                <label
                    className="required"
                    style={{
                        fontSize: "16px",
                        color: "#626262",
                        padding: "0 10px",
                        fontFamily: "Karbon-medium",

                    }}
                >
                    Image
                </label>
                {image && (
                    <img style={{width: "100%", maxHeight: "100px"}}
                        src={typeof image === "string" ? image : URL.createObjectURL(image)}
                        alt="preview"
                        width={200}
                    />
                )}
                <input type="file" id="upload-image" onChange={imageHandler} />
            </div>

            {/* Icon Upload */}
            <div style={{ display: "flex", width: "100%", gap: "20px", flexDirection: "column" }}>
                <label
                    className="required"
                    style={{
                        fontSize: "16px",
                        color: "#626262",
                        padding: "0 10px",
                          fontFamily: "Karbon-medium",
                    }}
                >
                    Icon
                </label>
                {icon && (
                    <img  style={{width: "100%", maxHeight: "100px"}}
                        src={typeof icon === "string" ? icon : URL.createObjectURL(icon)}
                        alt="preview"
                        width={200}
                        height={200}
                    />
                )}
                <input type="file" id="upload-icon" onChange={iconHandler} />
            </div>

            {/* Buttons */}
            <div style={{ width: "100%", display: "flex", gap: "10px", justifyContent: "end", fontFamily: "Karbon-medium"}}>
                <button
                    type="reset"
                    className="btn btn-sm btn-white me-2"
                    onClick={() => closeModal()}
                >
                    Cancel
                </button>
                <button
                    onClick={handleSubmit}
                    style={{
                        color: selectedButtonColors,
                        background: selectedButtonBackgoundColors,
                        border: "none",
                        padding: "10px 15px",
                        borderRadius: "20px",
                          fontFamily: "Karbon-medium",

                    }}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default EditServiceModal;
